<mat-dialog-content>
  <div class="changelog-dialog-title-container">
    <span class="changelog-dialog-title">
      {{ fieldsCount }} sections changed
    </span>

    <a
      class="gym-link"
      target="_blank"
      href="/gym-location/gymfinder/gym/{{ changelog.gymId }}/details">
      View internal admin gym page
      <mat-icon>north_east</mat-icon>
    </a>
  </div>

  @if (true) {
    <table
      mat-table
      [dataSource]="changelog.metadata"
      class="change-log-details-table">
      <ng-container matColumnDef="field">
        <th mat-header-cell *matHeaderCellDef>Field</th>
        <td mat-cell *matCellDef="let element">
          {{ element.formattedField }}
        </td>
      </ng-container>
      <ng-container matColumnDef="oldValue">
        <th mat-header-cell *matHeaderCellDef>Before</th>
        <td mat-cell *matCellDef="let element">
          <gymfinder-changelog-cell
            [field]="element.field"
            [value]="element.oldValue" />
        </td>
      </ng-container>
      <ng-container matColumnDef="newValue">
        <th mat-header-cell *matHeaderCellDef>After</th>
        <td mat-cell *matCellDef="let element">
          <gymfinder-changelog-cell
            [field]="element.field"
            [value]="element.newValue" />
        </td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
      class="change-log-details-header"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      class="change-log-details-row"></tr>
    </table>
  }
</mat-dialog-content>

<mat-dialog-actions class="changelog-actions">
  <button mat-raised-button (click)="closeDialog()">Go back</button>
  @if (canBeMarkedAsViewed()) {
    <button
      mat-raised-button
      color="primary"
      (click)="markAsViewed()">
      Mark as Viewed
    </button>
  }
</mat-dialog-actions>
